import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { TagValues } from "@/model/data/Tag";
import { InstalledSoftware } from "@/model/data/InstalledSoftware";
import { IsNamedSoftwareVersion, NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { FetchInstallationCaosConfigurationResData } from "./FetchInstallationCaosConfigurationResData";

const ENDPOINT = "/caosconfiguration/";

export class FetchInstallationCaosConfigurationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationCaosConfigurationReqData;

    constructor(payload: FetchInstallationCaosConfigurationReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationCaosConfigurationResData> {
        let res = await this.executeCommand(this.payload);
        return new FetchInstallationCaosConfigurationResData(res);
    }
}

export class FetchInstallationCaosConfigurationReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
    softwareVersionFilterList: InstalledSoftware[] = [];
}

export function GetFetchInstallationsCaosConfigurationReqData(req: FetchInstallationCaosConfigurationReqData): FetchInstallationCaosConfigurationReqData {
    let softwareVersionFilterList: InstalledSoftware[] = [];
    let reqProps = Object.keys(req);

    reqProps.forEach((prop) => {
        if (Array.isArray(req[prop]) && IsNamedSoftwareVersion(req[prop][0])) {
            req[prop].forEach((softwareFilter: NamedSoftwareVersion) => {
                let sw = new InstalledSoftware();

                if (Object.keys(UpdateTypeEnum).includes(softwareFilter.name)) sw.updateType = UpdateTypeEnum[softwareFilter.name];
                else sw.updateType = UpdateTypeEnum.ThirdPartySoftware;

                sw.name = softwareFilter.name;
                sw.version = softwareFilter.version;
                softwareVersionFilterList.push(sw);
            });
        }
    });

    let res: FetchInstallationCaosConfigurationReqData = {
        installationNames: req.installationNames,
        folderIds: req.folderIds,
        branchNames: req.branchNames,
        queryLimit: req.queryLimit,
        offset: req.offset,
        orderBy: req.orderBy,
        orderByDescending: req.orderByDescending,
        installationLastMessageDateRange: req.installationLastMessageDateRange,
        agentLastMessageDateRange: req.agentLastMessageDateRange,
        machineModels: req.machineModels,
        tagValues: req.tagValues,
        softwareVersionFilterList: softwareVersionFilterList,
    };

    return res;
}
